var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 0.25C4.62 0.25 0.25 4.62 0.25 10C0.25 15.38 4.62 19.75 10 19.75C15.38 19.75 19.75 15.38 19.75 10C19.75 4.62 15.38 0.25 10 0.25ZM10 18.25C5.45 18.25 1.75 14.55 1.75 10C1.75 5.45 5.45 1.75 10 1.75C14.55 1.75 18.25 5.45 18.25 10C18.25 14.55 14.55 18.25 10 18.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.5295 6.47C13.2395 6.18 12.7595 6.18 12.4695 6.47L9.99945 8.94L7.52945 6.47C7.23945 6.18 6.75945 6.18 6.46945 6.47C6.17945 6.76 6.17945 7.24 6.46945 7.53L8.93945 10L6.46945 12.47C6.17945 12.76 6.17945 13.24 6.46945 13.53C6.61945 13.68 6.80945 13.75 6.99945 13.75C7.18945 13.75 7.37945 13.68 7.52945 13.53L9.99945 11.06L12.4695 13.53C12.6195 13.68 12.8095 13.75 12.9995 13.75C13.1895 13.75 13.3795 13.68 13.5295 13.53C13.8195 13.24 13.8195 12.76 13.5295 12.47L11.0595 10L13.5295 7.53C13.8195 7.24 13.8195 6.76 13.5295 6.47Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/cross-circle.7f5ece74c0260829b1f3654b4619c65f.svg";
export { ForwardRef as ReactComponent };